/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-11-12 11:00:16
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-11-12 11:00:19
 * @FilePath: /designcenter/src/hooks/useFormCache.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// src/hooks/useFormCache.ts
import { ref, watch, onMounted } from 'vue'

export function useFormCache<T extends Record<string, any>>(key: string, defaultForm: T) {
  const form = ref<T>({ ...defaultForm })

  // 从localStorage加载缓存数据
  const loadCache = () => {
    try {
      const cached = localStorage.getItem(key)
      if (cached) {
        const cachedData = JSON.parse(cached)
        Object.assign(form.value, cachedData)
      }
    } catch (error) {
      console.warn('Failed to load form cache:', error)
    }
  }

  // 保存数据到localStorage
  const saveCache = () => {
    try {
      localStorage.setItem(key, JSON.stringify(form.value))
    } catch (error) {
      console.warn('Failed to save form cache:', error)
    }
  }

  // 监听表单变化并自动保存
  watch(form, saveCache, { deep: true })

  // 组件挂载时加载缓存
  onMounted(loadCache)

  return { form, saveCache, loadCache }
}
